var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-fade-in" } }, [
    _vm.MarketingShow
      ? _c("div", { staticClass: "mask" }, [
          _vm.MarketingShow
            ? _c("div", { staticClass: "dlog2" }, [
                _c(
                  "div",
                  {
                    staticClass: "dlog2Content",
                    style: _vm.MarketingInfo.popupBgImg
                      ? "background-image: url(" +
                        _vm.MarketingInfo.popupBgImg +
                        ");"
                      : ""
                  },
                  [
                    _c("img", {
                      staticClass: "dlog2Colse",
                      attrs: {
                        src: "https://img.webloom.cn/Img/cujiuaofeiClose.png",
                        alt: ""
                      },
                      on: { click: _vm.closeDialog }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.MarketingInfo.topicTitle))
                    ]),
                    _vm._v(" "),
                    _vm.MarketingInfo && _vm.MarketingInfo.topicDesc
                      ? _c("div", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.MarketingInfo.topicDesc))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.MarketingInfo
                      ? _c(
                          "div",
                          {
                            staticClass: "dlog2Content-main",
                            attrs: { id: "dlog2Content-main" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "dlog2Content-main-title1",
                                attrs: { id: "activityName" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.MarketingInfo.activityName ||
                                      "限时优惠活动"
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dlog2Content-main-title2",
                                attrs: { id: "activityDesc" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.MarketingInfo.activityDesc || "限时立减"
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "priceBox" }, [
                              _c("div", { staticClass: "txt1" }, [
                                _vm._v("当前价格")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "txt2" }, [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.MarketingInfo.currentPrice
                                        ? _vm.MarketingInfo.currentPrice / 100
                                        : 0
                                    )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "txt3" }, [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.MarketingInfo.originalPrice
                                        ? _vm.MarketingInfo.originalPrice / 100
                                        : 0
                                    )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.MarketingInfo.discountInfo
                              ? _c("div", { staticClass: "tipBox" }, [
                                  _c("div", { staticClass: "tip" }, [
                                    _c("img", {
                                      staticClass: "tipImg",
                                      attrs: {
                                        src:
                                          "https://img.webloom.cn/Img/cujiuaofeisjx.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.MarketingInfo.discountInfo) +
                                        "\n            "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "btnBox" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "btn",
                                  attrs: { id: "btn" },
                                  on: { click: _vm.handleToMarketing }
                                },
                                [
                                  _c("div", { staticClass: "btnTip" }, [
                                    _c("div", { staticClass: "btnTiptxt1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.MarketingInfo.timeLimitTxt ||
                                            "优惠即将失效"
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.timeLimit
                                      ? _c(
                                          "div",
                                          { staticClass: "btnTiptxt2" },
                                          [_vm._v(_vm._s(_vm.remainingTxt))]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(
                                    "\n              前往缴费\n            "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "look" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "lookTip",
                                  on: { click: _vm.handleToMarketing }
                                },
                                [_vm._v(_vm._s(_vm.MarketingInfo.bottomTips))]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7be365b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7be365b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/PaymentGuideDialog.vue
// module id = null
// module chunks = 